<div class="stage">
  <div style="text-align: center">
    <span class="mat-title"> Escolha um plano para efetuar seu cadastro </span>
  </div>

  <!-- <app-plan-slide #PlanSlide (choosePlan)="choosePlan($event)"></app-plan-slide> -->

  <ng-container>
    <div class="empty-content">
      <p class="mat-body-2">Você está no Plano Gratuito</p>
    </div>
  </ng-container>

  <form
    [formGroup]="formPlan"
    (submit)="
      choosePlan({
        index: 1,
        code: 'FREE',
        title: 'Plano Free',
        price: '0,00',
        period: 'mensal',
        selected: true
      })
    "
  >
    <div class="row">
      <mat-checkbox color="primary" formControlName="acceptTerm" required>
        Aceito os termos de uso da plataforma
        <a
          href="https://colloca.com.br/wp-content/uploads/2024/01/Termos-de-uso-Politica-de-Privacidade-e-LGPD.pdf"
          target="_blank"
          >(ler termo de uso)</a
        >
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-error *ngIf="!formPlan.get('acceptTerm').value">
        É necessário aceitar os termos de uso
      </mat-error>
    </div>
    <div class="row">
      <mat-checkbox color="primary" formControlName="acceptContract" required>
        Aceito o contrato da plataforma
        <a
          href="https://colloca.com.br/wp-content/uploads/2024/01/CONTRATO-PF-Ajustado-24.01.2024.pdf"
          target="_blank"
          >(ler contrato)</a
        >
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-error *ngIf="!formPlan.get('acceptContract').value">
        É necessário aceitar o contrato
      </mat-error>
    </div>
    <!-- <div class="row">
            <mat-checkbox color="primary" formControlName="acceptSendMessage">
                Autorizo que a Colloca me envie mensagens de vagas e informações sobre a ferramenta
            </mat-checkbox>
        </div> -->
    <div class="actions">
      <button
        class="custom-primary"
        mat-raised-button
        type="submit"
        [disabled]="!formPlan.valid"
        (click)="doneAll()"
        matStepperNext
      >
        Concluir
      </button>
    </div>
  </form>
</div>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
